<template>
    <div class="content">
        <div class="content_details">
            <!-- <span class="details">{{title}}</span> -->
            <div class="main" v-html="announcementnot"></div>
        </div>

    </div>
</template>

<script>
export default {
    props: ["detailsId", "status"],
    data() {
        return {
            detail: "",
            id: "",
            dId: "",
            dStatus: "",

            detailsnotice: [{
                //中国邮政集团有限公司
                announcement: '<p style="text-align: left;"><br/><br/></p><p style="text-align: center;"><strong>关于部分境外邮政服务异常情况的公告</strong>&nbsp;&nbsp;&nbsp; <br/></p><p style="text-align: left;"><br/><br/>&nbsp;&nbsp; 尊敬的客户：</p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 随着新型冠状病毒在境外多点爆发，部分国家和地区采取一系列防控措施，导致境外邮政暂停或延迟服务，中国邮政进出口国际及港澳台邮件运递时限较平时有较大程度延长。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 由于邮件寄递时限延长造成的不便，恳请您的谅解。中国邮政将竭尽全力，保障您的用邮服务。一旦邮件运行秩序恢复正常，我们将第一时间公告。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 详情可见热点问题。<br/>&nbsp; <br/></p><p style="text-align: right;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 二〇二〇年三月二十四日<br/><br/></p><p></p>',
            },
            {
                //中国邮政速递物流股份有限公司
                announcement: '<p style="text-align: left;"><br/><br/></p><p style="text-align: center;"><strong>关于预防冒充邮政工作人员诈骗用户的公告</strong><br/><br/>&nbsp;&nbsp;&nbsp; <br/></p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 近期，我司接到一些用户反映，有人通过电话或伪装成邮政标识头像的微信，冒充邮政工作人员，联系用户谎称邮件丢失，欲对其进行赔偿，然后通过发送二维码、短信链接或下载手机APP等方式，诱导客户扫描或点击，诈骗用户钱财，如遇此情况，请不要相信，并建议报警处理，以防您的财产受到损失。<br/>&nbsp; <br/></p><p style="text-align: right;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 二〇一九年八月十四日</p><p></p>',
            },
            {
                announcement: '<p style="text-align: left;"><br/><br/></p><p style="text-align: center;"><strong>关于进疆邮件的服务公告</strong><br/><br/>&nbsp;&nbsp;&nbsp; <br/></p><p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 您好！自去年以来，由于不断升级的维稳要求，对寄往新疆的邮件执行更加严格的检查标准。除《禁止寄递物品管理规定》之外的各类刀具（如菜刀、水果刀、美工刀、剪刀、宝剑、武士刀等）以及二节棍、斧头、弹弓、各类警具等物品邮件，在进入新疆后将被查扣，无法发往前途，也无法退回。对此类邮件，邮政企业将依照相关规定，集中分批移交国家安全等相关部门。<br/><br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 为了保障您的合法权益，确保您的邮件不受损失，中国邮政站在为客户负责的角度，提示您：除《禁止寄递物品指导目录》上明确规定的禁寄物品外，请暂时不要向新疆邮寄上述物品（特别是要注意网购赠品中的小刀，厨具、成套刀具等），也不要通过网购途径购买上述物品寄往新疆，以避免因邮件扣压给您造成损失。<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;谢谢您对我们工作长期以来的大力支持，由此带来的不便敬请谅解。<br/><p style="text-align: right;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 二〇一九年一月二十五日</p></p><p></p>',
            },
            ],

            announcementnot: "",
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        // 详情
        init() {

            if (this.dId == 99) {
                this.announcementnot = this.detailsnotice[0].announcement;
            } else if (this.dId == 98) {
                this.announcementnot = this.detailsnotice[1].announcement;
            } else if (this.dId == 97) {
                this.announcementnot = this.detailsnotice[2].announcement;
            }

            if (this.dStatus == "news") {
                //         新闻
                let news_details = {
                    value: {
                        id: this.dId,
                    },
                };
                this.$axios
                    .post("/news/getNewsById", news_details)
                    .then((res) => {
                        this.title = res.value.newsTitle;
                        this.announcementnot = res.value.frontendContent;
                    })
                    .catch((err) => {
                        this.$message.error(err.data.message);
                    });
            } else if (this.dStatus == "announce" || this.dStatus == "tips") {
                // 服务公告
                // console.log("服务公告");
                let announce_details = {
                    value: {
                        id: this.dId,
                    },
                };
                this.$axios
                    .post("/announcement/getAnnouncementById", announce_details)
                    .then((res) => {
                        this.announcementnot = res.value.frontendContent;
                    })
                    .catch((err) => {
                        this.$message.error(err.data.message);
                    });
            } else if (this.dStatus == "popularize") {
                // 推广专区
                // console.log("推广专区");
                let gonggao = {
                    value: {
                        id: this.dId,
                    }
                };
                // console.log(gonggao)

                this.$axios
                    .post("/promotionZone/getPromotionZoneById", gonggao)
                    .then((res) => {
                        this.announcementnot = res.value.frontendContent;
                    })
                    .catch((err) => {
                        this.$message.error(err.data.message);
                    });
            }
        },
    },
    watch: {
        detailsId(newValue, oldValue) {
            this.dId = newValue.detailsId;
            this.dStatus = newValue.status;
            this.init();
        },
        status(newValue, oldValue) {
            this.dId = newValue.detailsId;
            this.dStatus = newValue.status;

            this.init();
        }
    }
};
</script>

<style lang="scss" scoped>
.details {
    font-size: 32px;
    font-weight: 400;
    color: #333333;
    text-align: center;
    display: block;
    line-height: 26px;
    margin: 60px 0 41px 0;
}

.content {
    // width: 100%;
    min-height: 400px;
    padding-bottom: 55px;

    .content_details {
        .main {
            margin: auto;
            padding: 0px 40px 0px 30px;

            ::v-deep {
                p {
                    width: 100%;
                    line-height: 30px;
                }
    
                img {
                    margin: auto;
                    width: 100%;
                }
    
                a {
                    color: #004b9c;
                    border-bottom: 1px solid #004b9c;
                }
            }

        }
    }
}
</style>